import React, { useState } from 'react';
import { Eye, EyeOff, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { useI18n } from '../../context/I18nContext';

const ProviderCredentialStepUpModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading = false,
  error = null,
  theme = null,
}) => {
  const { t } = useI18n();
  const CR = 'creditReport';
  const [fundelitePassword, setFundelitePassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleClose = () => {
    setFundelitePassword('');
    setShowPassword(false);
    onClose?.();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fundelitePassword || loading) return;
    try {
      await onSubmit(fundelitePassword);
      setFundelitePassword('');
      setShowPassword(false);
    } catch {
      // error surfaced via prop
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent
        className="sm:max-w-[420px]"
        style={{
          background: theme?.card?.bg || '#1A2F2A',
          border: `1px solid ${theme?.card?.border || '#2D4A44'}`,
          borderRadius: '22px',
        }}
        data-testid="provider-credential-step-up-modal"
      >
        <DialogHeader>
          <DialogTitle style={{ color: theme?.text?.primary || '#fff' }}>
            {t(`${CR}.confirmItsYou`)}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm" style={{ color: theme?.text?.secondary || '#E5E7EB' }}>
          {t(`${CR}.confirmItsYouBody`)}
        </p>
        <form onSubmit={handleSubmit} className="space-y-4 pt-2">
          <div className="relative">
            <Input
              type={showPassword ? 'text' : 'password'}
              value={fundelitePassword}
              onChange={(e) => setFundelitePassword(e.target.value)}
              placeholder={t(`${CR}.fundelitePasswordPlaceholder`)}
              autoComplete="current-password"
              className="selection:bg-emerald-600/30 selection:text-inherit"
              style={{
                background: theme?.surface?.s2 || '#0D1F1A',
                border: `1px solid ${theme?.border?.b2 || '#2D4A44'}`,
                color: theme?.text?.primary || '#fff',
                paddingRight: '40px',
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              className="absolute right-3 top-1/2 -translate-y-1/2"
              style={{ color: theme?.text?.muted || '#9CA3AF' }}
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
          {error && (
            <p className="text-sm text-red-400" data-testid="step-up-error">
              {error}
            </p>
          )}
          <div className="flex gap-3">
            <Button type="button" variant="outline" onClick={handleClose} className="flex-1">
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!fundelitePassword || loading}
              className="flex-1"
              style={{ opacity: loading ? 0.7 : 1 }}
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
              {t(`${CR}.verifyAndReveal`)}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ProviderCredentialStepUpModal;
